import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core'
import { skip } from 'rxjs/operators'
import { DialogType } from '@shared/components/dialog-application/dialog-application.enums'
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop'
import { ProfileStore } from '@core/store/profile/profile.store'
import { TenantStore } from '@core/store/tenant/tenant.store'
import { APPLICATION_CONFIG } from './header.constants'
import { TranslatePipe } from '@ngx-translate/core'
import { ApplicationMenu, Select as McuiSelect } from '@performance/ui'
import { MainLogo } from '@shared/components/main-logo/main-logo'
import { DialogApplication } from '@shared/components/dialog-application/dialog-application'
import { QuickView } from '@shared/components/quick-view/quick-view'
import { RouterLink } from '@angular/router'

@Component({
  selector: 'bo-header',
  templateUrl: './header.html',
  styleUrls: ['./header.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MainLogo,
    McuiSelect,
    DialogApplication,
    ApplicationMenu,
    QuickView,
    RouterLink,
    TranslatePipe,
  ],
})
export class Header {
  readonly #profileStore = inject(ProfileStore)
  readonly #tenantStore = inject(TenantStore)

  #firstRun = true

  readonly appConfig = APPLICATION_CONFIG
  readonly applicationDialogType = DialogType

  readonly isLoggedIn = this.#profileStore.isLoggedIn
  readonly isAdmin = this.#profileStore.isAdmin
  readonly formattedProfile = this.#profileStore.formattedProfile
  readonly userProfiles = this.#profileStore.userProfiles
  readonly tenantsAsDropdownItems = this.#tenantStore.tenantsAsDropdownItems
  readonly selectedTenant = signal<string | undefined>(undefined)

  constructor() {
    toObservable(this.#tenantStore.selectedTenantId)
      .pipe(takeUntilDestroyed())
      .subscribe((tenant) => {
        if (this.#firstRun && !!tenant) {
          this.#firstRun = false
          this.selectedTenant.set(tenant)
        }
      })

    toObservable(this.selectedTenant)
      .pipe(skip(1), takeUntilDestroyed())
      .subscribe((selected) => this.#tenantStore.setSelectedTenant(selected ?? null))
  }
}
